<template>
        <div class="ym_top bgb">
            <a class="back" href="javascript:;" @click="goback"></a>
            <h2>{{title}}</h2>
        </div>
</template>

<script>
export default {
 props: {
    title: {
      type: String,
      default:  '39疫苗快查' 
    }},

  data() {      
    return {
     
    };
  },
  methods: {
    goback() {
        this.$router.go(-1);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/nav.vue